import "./App.css";
import { Excalidraw } from "@excalidraw/excalidraw";
import { useEffect, useRef, useState } from "react";

function App() {
  const excalidrawRef = useRef(null);
  const [initialData, setInitialData] = useState(null);

  // Load dữ liệu từ localStorage khi app load
  useEffect(() => {
    const savedData = localStorage.getItem("excalidraw");
    if (savedData) {
      setInitialData(JSON.parse(savedData));
    }
  }, []);

  // Hàm lưu dữ liệu mỗi khi có thay đổi
  const handleChange = (elements, appState) => {
    const dataToSave = {
      elements,
      appState: {
        viewBackgroundColor: appState.viewBackgroundColor,
      },
    };
    localStorage.setItem("excalidraw", JSON.stringify(dataToSave));
  };

  return (
    <div className="App">
      <div style={{ height: "100vh" }}>
        <Excalidraw ref={excalidrawRef} initialData={initialData} onChange={handleChange} />
      </div>
    </div>
  );
}

export default App;
